module.exports = __webpack_public_path__ + "static/img/b46.4c54471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b46.png
// module id = T+Nc
// module chunks = 0